<vdr-card class="mb-4">
    <div class="flex items-center justify-between mb-4">
        <h4 class="text-xl font-semibold">Send Notification</h4>
    </div>
    <form [formGroup]="detailForm">
        <div class="form-grid">
            <vdr-form-field label="Title" for="title">
                <input id="title" type="text" formControlName="title" />
            </vdr-form-field>
            <vdr-rich-text-editor
                class="form-grid-span"
                formControlName="body"
                label="Body"
            ></vdr-rich-text-editor>
            <vdr-form-field label="Include Banner" for="includeBanner">
                <input id="includeBanner" type="checkbox" clrCheckbox formControlName="includeBanner" />
            </vdr-form-field>
            <vdr-form-field label="Send Via" for="medium">
                <div class="flex flex-col gap-2">
                    <label class="checkbox-item flex items-center gap-2 mx-1">
                        <input type="checkbox" clrCheckbox formControlName="sendSms" />
                        <span>SMS</span>
                    </label>
                    <label class="checkbox-item flex items-center gap-2 mx-1">
                        <input type="checkbox" clrCheckbox formControlName="sendEmail" />
                        <span>Email</span>
                    </label>
                    <label class="checkbox-item flex items-center gap-2">
                        <input type="checkbox" clrCheckbox formControlName="sendInApp" />
                        <span>In App Notification</span>
                    </label>
                </div>
            </vdr-form-field>
        </div>
    </form>

    <div class="mt-4 flex justify-end">
        <button type="button" class="btn btn-primary" (click)="sendNotification()">Send Notification</button>
    </div>
</vdr-card>
